import { useState } from "react";
import { ArrowUpRight, ArrowDownRight, ImageOff } from "lucide-react";
import { BACKEND_URL } from "@/lib/api";

export const SkuThumb = ({ sku, alt = "", size = "h-10 w-10" }) => {
  const [err, setErr] = useState(false);
  if (!sku || err)
    return (
      <div className={`${size} shrink-0 rounded-md bg-muted flex items-center justify-center`}>
        <ImageOff className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
      </div>
    );
  const token = localStorage.getItem("access_token");
  const src = `${BACKEND_URL}/api/thumbnails?sku=${encodeURIComponent(sku)}${token ? `&auth_token=${encodeURIComponent(token)}` : ""}`;
  return (
    <img src={src} alt={alt} loading="lazy"
      onError={() => setErr(true)}
      className={`${size} shrink-0 rounded-md object-contain bg-white border border-border`} />
  );
};

export const StatCard = ({ label, value, delta, sub, testId }) => (
  <div className="bg-card border border-border rounded-lg p-5 shadow-sm hover:-translate-y-1 hover:shadow-md transition-transform" data-testid={testId}>
    <p className="text-xs tracking-[0.2em] uppercase font-semibold text-muted-foreground">{label}</p>
    <p className="font-heading text-2xl sm:text-3xl font-bold tracking-tight mt-2">{value}</p>
    <div className="flex items-center gap-2 mt-1.5 min-h-[20px]">
      {typeof delta === "number" && (
        <span className={`inline-flex items-center gap-0.5 text-xs font-semibold ${delta >= 0 ? "text-green-600" : "text-red-600"}`}>
          {delta >= 0 ? <ArrowUpRight className="h-3 w-3" aria-hidden="true" /> : <ArrowDownRight className="h-3 w-3" aria-hidden="true" />}
          {Math.abs(delta)}%
        </span>
      )}
      {sub && <span className="text-xs text-muted-foreground">{sub}</span>}
    </div>
  </div>
);

export const DaysToggle = ({ value, onChange }) => (
  <div className="inline-flex rounded-full border border-border bg-card p-1" data-testid="days-toggle">
    {[30, 60, 90].map((d) => (
      <button
        key={d}
        onClick={() => onChange(d)}
        data-testid={`days-${d}`}
        className={`px-4 py-1.5 text-xs font-semibold rounded-full transition-colors ${
          value === d ? "bg-blue-600 text-white" : "text-muted-foreground hover:text-foreground"
        }`}
      >
        {d}d
      </button>
    ))}
  </div>
);

export const Skeleton = ({ className = "" }) => (
  <div className={`animate-pulse rounded-lg bg-muted ${className}`} />
);
